if (!customElements.get('mega-menu-v2')) {
  customElements.define('mega-menu-v2', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.details = this.querySelector('details');
      this.trigger = this.querySelector('summary');
      this.panel = this.querySelector('.mega-menu-v2-panel');
      this.content = this.panel.querySelector('.mega-menu-v2');
      this.isOpen = this.details.open;
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.trigger.setAttribute('aria-expanded', String(this.isOpen));

      this.trigger.addEventListener('click', event => {
        event.preventDefault();
        this.setOpen(!this.isOpen);
      }, options);

      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.close();
      }, options);

      document.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !this.isOpen) return;
        this.close();
        this.trigger.focus();
      }, options);

      document.addEventListener('focusin', event => {
        if (!this.contains(event.target)) this.close();
      }, options);

      window.addEventListener('resize', () => this.close(true), options);
      window.addEventListener('scroll', () => this.close(true), { ...options, passive: true });

      document.addEventListener('shopify:block:select', event => {
        if (this.closest('[data-shopify-editor-block]') === event.target || event.target.contains(this)) {
          this.setOpen(true);
        }
      }, options);

      document.addEventListener('shopify:block:deselect', () => this.close(), options);
    }

    setOpen(open, immediate = false) {
      if (this.isOpen === open && !immediate) return;
      if (!open && !this.details.open) return;

      const from = this.details.open ? getComputedStyle(this.content).transform : 'translateY(-100%)';
      this.animation?.cancel();
      this.animation = null;
      this.isOpen = open;
      this.trigger.setAttribute('aria-expanded', String(open));
      this.panel.inert = !open;

      if (open) {
        const legacyMenus = document.querySelectorAll('.desktop-navbar .dropdown.open');
        if (legacyMenus.length) {
          legacyMenus.forEach(menu => {
            menu.classList.remove('open');
            menu.querySelector('[is="drop-down"]')?.setAttribute('aria-expanded', 'false');
          });
          document.querySelector('site-overlay')?.hideOverlay();
        }
        document.querySelectorAll('mega-menu-v2').forEach(menu => {
          if (menu !== this) menu.close(true);
        });
        this.details.open = true;
      }

      if (immediate || this.motionPreference.matches) {
        this.details.open = open;
        return;
      }

      const animation = this.content.animate([
        { transform: from },
        { transform: open ? 'translateY(0)' : 'translateY(-100%)' }
      ], { duration: 550, easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)', fill: 'both' });
      this.animation = animation;
      animation.finished.then(() => {
        if (this.animation !== animation) return;
        this.details.open = this.isOpen;
        animation.cancel();
        this.animation = null;
      }, () => {});
    }

    close(immediate = false) {
      this.setOpen(false, immediate);
    }

    disconnectedCallback() {
      this.animation?.cancel();
      this.events.abort();
    }
  });
}
